import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAuditLighthouseDto } from '../../models/IAuditLighthouseDto';
import { baseService } from '../base.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuditLighthouseService extends baseService {

  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  private apiRoute: string = '';

  async createAuditLighthouseDatabase(auditLighthouseDto: IAuditLighthouseDto) {
    this.apiRoute = 'auditlighthouse';
    return this.post(`/${this.apiRoute}`, auditLighthouseDto).toPromise();
  }

  async syncAuditDatabase(profileId: string) {
    this.apiRoute = `auditlighthouse/${profileId}/sync`;
    return this.get(`/${this.apiRoute}`).toPromise();
  }
}
